var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckcomponent = function SvgCheckcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.744 9.804a.75.75 0 0 0 1.012 0l8.039-7.697a.674.674 0 0 0 0-.968L12.81.196a.715.715 0 0 0-.984 0L5.264 6.48l-3.09-2.932a.715.715 0 0 0-.985 0l-.984.943a.674.674 0 0 0 0 .968l4.54 4.346Z"
  })));
};
export default SvgCheckcomponent;